import React,{useState} from 'react';
import {GoogleLogin,GoogleLogout} from 'react-google-login';

// let clientId = '975381720421-nld94ekpnlcgoiplc2en2il5krd4maii.apps.googleusercontent.com';

const Login = () => {
    let clientId = '975381720421-q3mlgmlln90sirvp26t33ennu58nkovg.apps.googleusercontent.com';
    let secretClientId = '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';
    const [showloginButton, setShowloginButton] = useState(true);
    const [showlogoutButton, setShowlogoutButton] = useState(false);
    const onLoginSuccess = (res) => {
        console.log('Login Success:', res.profileObj);
        setShowloginButton(false);
        setShowlogoutButton(true);
    };

    const onLoginFailure = (res) => {
        console.log('Login Failed:', res);
    };

    const onSignoutSuccess = () => {
        alert("You have been logged out successfully");
        console.clear();
        setShowloginButton(true);
        setShowlogoutButton(false);
    };


  return (
    <div>
        {
            showloginButton?
            <GoogleLogin
            clientId={clientId}
            buttonText="Sign In"
            onSuccess={onLoginSuccess}
            onFailure={onLoginFailure}
            // cookiePolicy={'single_host_origin'}
            isSignedIn={true}>
            </GoogleLogin>:null
        }
         { showlogoutButton?
                <GoogleLogout
                clientId={clientId}
                buttonText="Sign Out"
                onLogoutSuccess={onSignoutSuccess}
                >
                </GoogleLogout> : null
            }
    </div>
  )
}

export default Login